const DEFAULT_TIMEOUT_MS = 15000;

// Reloads once the scoring store has saved every pending answer, so a language
// switch drops no responses. A save error or a timeout calls onError and keeps
// the student on the page.
export const reloadWhenSaved = ({ state$, reload, onError, timeoutMs = DEFAULT_TIMEOUT_MS }) => {
  let sub = null;
  let timer = null;
  let done = false;

  const stop = () => {
    done = true;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    if (sub) {
      sub.unsubscribe();
      sub = null;
    }
  };

  timer = setTimeout(() => {
    if (done) return;
    stop();
    onError({ type: 'timeout' });
  }, timeoutMs);

  // scoreProgress is absent until the first answer is entered.
  sub = state$.subscribe(({ scoreProgress }) => {
    if (done) return;
    if (scoreProgress?.error) {
      stop();
      onError(scoreProgress.error);
    } else if (!scoreProgress?.anyUnsavedChanges) {
      stop();
      reload();
    }
  });

  // BehaviorSubject replays synchronously inside subscribe(), before `sub` is
  // assigned. If that first value already resolved, tear the subscription down now.
  if (done) stop();

  return sub;
};
